import ProductCharacteristics from './ProductCharacteristics'

export default ProductCharacteristics
